import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const AdminRoute = () => {
    const { loading, user } = useSelector(state=> state.user);

    const navigate = useNavigate();
    useEffect(()=>{
        loading == false ?   navigate('/dashboard'):navigate('/login')

    })

    
    
   
}

export default AdminRoute;